import React, { useState, useEffect } from 'react';

const Home = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [audio] = useState(new Audio('/I m Abhay Keshri A p.mp3')); // Initialize audio
  const [isPlaying, setIsPlaying] = useState(false); // Track audio playback state

  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById('about');
      if (element) {
        const top = element.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        if (top < windowHeight * 0.75) {
          setIsVisible(true);
        }
      }
    };

    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener('resize', checkMobile);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Toggle audio playback
  const toggleAudio = () => {
    if (isPlaying) {
      audio.pause();
      audio.currentTime = 0; // Reset to start
    } else {
      audio.play();
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <>
      {/* Introduction Section */}
      <section
        id="home"
        style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: isMobile ? '30px 5%' : '80px 5%',
          background: 'linear-gradient(135deg, rgb(0, 0, 0), rgb(0, 0, 0), rgb(11, 6, 20))',
          color: '#ffffff',
          minHeight: '100vh',
          position: 'relative',
          overflow: 'hidden',
          textAlign: isMobile ? 'center' : 'left',
        }}
      >
        {/* Cosmic background elements */}
        <div
          style={{
            position: 'absolute',
            top: '-100px',
            right: '-100px',
            width: isMobile ? '300px' : '400px',
            height: isMobile ? '300px' : '400px',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(73, 179, 255, 0.3) 0%, rgba(128, 244, 255, 0) 70%)',
            zIndex: 0,
            animation: 'nebulaDrift 12s ease-in-out infinite',
          }}
        />
        <div
          style={{
            position: 'absolute',
            bottom: '-150px',
            left: '-150px',
            width: isMobile ? '350px' : '500px',
            height: isMobile ? '350px' : '500px',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(75, 0, 130, 0.3) 0%, rgba(0,0,0,0) 70%)',
            zIndex: 0,
            animation: 'nebulaDrift 15s ease-in-out infinite',
          }}
        />

        {/* Left side - Text content */}
        <div
          style={{
            flex: isMobile ? '0 1 auto' : '1',
            maxWidth: '600px',
            paddingRight: isMobile ? '0' : '40px',
            position: 'relative',
            zIndex: 1,
            marginBottom: isMobile ? '20px' : '0',
            marginTop: isMobile ? '80px' : '',
          }}
        >
          <h1
            style={{
              fontSize: isMobile ? '1.6rem' : 'clamp(2rem, 5vw, 3.5rem)',
              marginBottom: '15px',
              lineHeight: '1.3',
              opacity: 0,
              animation: 'fadeInUp 1s ease forwards 0.3s',
            }}
          >
            Hello, I'm <br />
            <span
              style={{
                fontSize: isMobile ? '1.8rem' : 'clamp(2.5rem, 6vw, 4rem)',
                fontWeight: '700',
                background: 'linear-gradient(90deg, #9370db, #4b0082)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                display: 'inline-block',
                marginTop: '10px',
              }}
            >
              ABHAY KESHRI
            </span>
          </h1>
          <h2
            style={{
              fontSize: isMobile ? '0.9rem' : 'clamp(1.2rem, 3vw, 1.5rem)',
              fontWeight: '400',
              marginBottom: '20px',
              color: '#d8bfd8',
              opacity: 0,
              animation: 'fadeInUp 1s ease forwards 0.5s',
            }}
          >
            Full Stack Developer | Tech Enthusiast | Problem Solver
          </h2>
          <div
            style={{
              opacity: 0,
              animation: 'fadeInUp 1s ease forwards 0.7s',
              display: 'flex',
              justifyContent: isMobile ? 'center' : 'flex-start',
            }}
          >
            <a
              href="#project"
              style={{
                padding: isMobile ? '8px 12px' : '10px 16px',
                background: 'linear-gradient(90deg, #9370db, #4b0082)',
                color: 'white',
                borderRadius: '25px',
                textDecoration: 'none',
                fontWeight: '600',
                fontSize: isMobile ? '0.8rem' : '0.9rem',
                display: 'inline-flex',
                alignItems: 'center',
                transition: 'all 0.3s ease',
                boxShadow: '0 3px 12px rgba(147, 112, 219, 0.5)',
                marginTop: '15px',
                position: 'relative',
                overflow: 'hidden',
                width: isMobile ? '150px' : '160px',
                textAlign: 'center',
                minHeight: '32px',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 5px 15px rgba(147, 112, 219, 0.7)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 3px 12px rgba(147, 112, 219, 0.5)';
              }}
            >
              View My Projects
              <span
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  background: 'rgba(255,255,255,0.2)',
                  transform: 'translateX(-100%)',
                  transition: 'transform 0.3s ease',
                }}
              />
            </a>
          </div>
        </div>

        {/* Right side - Image */}
        <div
          style={{
            flex: isMobile ? '0 1 auto' : '1',
            display: 'flex',
            justifyContent: 'center',
            position: 'relative',
            zIndex: 1,
            opacity: 0,
            animation: 'fadeIn 1s ease forwards 0.9s',
            width: isMobile ? '100%' : 'auto',
          }}
        >
          <div
            style={{
              width: isMobile ? '220px' : 'clamp(250px, 30vw, 350px)',
              height: isMobile ? '220px' : 'clamp(250px, 30vw, 350px)',
              borderRadius: '100%',
              overflow: 'hidden',
              border: isMobile ? '3px solid rgba(0, 0, 0, 0.3)' : '8px solid rgba(0, 0, 0, 0.3)',
              boxShadow: '0 0 40px rgba(147, 112, 219, 0.5)',
              position: 'relative',
              transition: 'transform 0.3s',
            }}
          >
            <img
              src="https://pub-dd2f474c91db40e89572c0c2e085b607.r2.dev/Untitled%20design%20(1).gif"
              alt="Abhay Keshri"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: 'center',
              }}
            />
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.2), rgba(75, 0, 130, 0.2))',
                borderRadius: '50%',
              }}
            />
          </div>
        </div>

        <style jsx>{`
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          @keyframes fadeIn {
            from {
              opacity: 0;
            }
            to {
              opacity: 1;
            }
          }
          @keyframes nebulaDrift {
            0%, 100% {
              transform: translate(0, 0) scale(1);
              opacity: 0.3;
            }
            50% {
              transform: translate(20px, -20px) scale(1.1);
              opacity: 0.5;
            }
          }
          a:hover span {
            transform: translateX(100%);
          }
          @media (max-width: 480px) {
            section {
              padding: 20px 5%;
            }
            h1 {
              font-size: 1.4rem !important;
            }
            h1 span {
              font-size: 1.6rem !important;
            }
            h2 {
              font-size: 0.85rem !important;
            }
          }
        `}</style>
      </section>

      {/* About Section */}
      <section
        id="about"
        style={{
          padding: isMobile ? '30px 0' : '80px 0',
          position: 'relative',
          overflow: 'hidden',
          background: 'radial-gradient(circle at center, rgb(4, 4, 4) 0%, rgb(5, 5, 5) 70%)',
          color: '#e0e0e0',
          opacity: isVisible ? 1 : 0,
          transition: 'opacity 0.6s ease',
        }}
      >
        <div
          style={{
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '0 20px',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row-reverse',
              alignItems: 'center',
              gap: isMobile ? '20px' : '60px',
              flexWrap: 'wrap',
              justifyContent: 'center',
            }}
          >
            {/* About Text */}
            <div
              style={{
                minWidth: isMobile ? '280px' : 'auto',
              }}
            >
              <h2
                style={{
                  fontSize: isMobile ? '1.4rem' : 'clamp(1.8rem, 4vw, 2.5rem)',
                  fontWeight: '700',
                  marginBottom: '15px',
                  color: '#ffffff',
                  lineHeight: '1.3',
                  textShadow: '0 0 10px rgba(179, 153, 232, 0.7)',
                  position: 'relative',
                }}
              >
                Overview.
                <span
                  style={{
                    position: 'absolute',
                    bottom: 0,
                    left: isMobile ? '50%' : '0',
                    transform: isMobile ? 'translateX(-50%)' : 'none',
                    width: '60px',
                    height: '4px',
                    background: 'linear-gradient(90deg, #9370db, rgb(0, 0, 0))',
                    borderRadius: '2px',
                    animation: 'nebulaGlow 2s ease-in-out infinite',
                  }}
                />
              </h2>
              <p
                style={{
                  fontSize: isMobile ? '0.85rem' : '1.1rem',
                  lineHeight: '1.8',
                  color: '#d8bfd8',
                  marginBottom: '20px',
                  textShadow: '0 0 5px rgba(147, 112, 219, 0.3)',
                }}
              >
                I'm <strong style={{ color: '#ffffff' }}>Abhay Keshri</strong>, a passionate Web & Mobile Developer with a Bachelor's degree in Computer Applications. I specialize in creating intuitive, high-performance applications that deliver exceptional user experiences.
              </p>
              <p
                style={{
                  fontSize: isMobile ? '0.85rem' : '1.1rem',
                  lineHeight: '1.8',
                  color: '#d8bfd8',
                  marginBottom: '20px',
                  textShadow: '0 0 5px rgba(147, 112, 219, 0.3)',
                }}
              >
                My expertise includes <strong style={{ color: '#ffffff' }}>JavaScript, React, Node.js, Python, and SQL</strong>. I'm dedicated to crafting scalable, modern solutions that solve real-world problems while maintaining clean, efficient code.
              </p>
              {/* CTA Buttons */}
              <div
                style={{
                  display: 'flex',
                  gap: '10px',
                  flexWrap: 'wrap',
                  justifyContent: isMobile ? 'center' : 'flex-start',
                }}
              >
                <a
                  href="/abhay resume.pdf"
                  download
                  style={{
                    padding: isMobile ? '8px 12px' : '10px 16px',
                    background: 'linear-gradient(90deg, #9370db, #4b0082)',
                    color: '#ffffff',
                    borderRadius: '6px',
                    textDecoration: 'none',
                    fontWeight: '600',
                    fontSize: isMobile ? '0.8rem' : '0.9rem',
                    transition: 'all 0.3s ease',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '6px',
                    boxShadow: '0 3px 12px rgba(147, 112, 219, 0.5)',
                    position: 'relative',
                    overflow: 'hidden',
                    animation: isVisible ? 'starPulse 2s ease-in-out infinite' : 'none',
                    width: isMobile ? '140px' : '150px',
                    justifyContent: 'center',
                    minHeight: '32px',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.05)';
                    e.currentTarget.style.boxShadow = '0 5 Cemexs 15px rgba(147, 112, 219, 0.7)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.boxShadow = '0 3px 12px rgba(147, 112, 219, 0.5)';
                  }}
                >
                  <svg width="14" height="14" viewBox="0 0  Nesta24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '4px' }}>
                    <path d="M12 15V3M12 15L8 11M12 15L16 11M21 15V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Download Resume
                  <span
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      background: 'rgba(255,255,255,0.2)',
                      transform: 'translateX(-100%)',
                      transition: 'transform 0.3s ease',
                    }}
                  />
                </a>
                <a
                  href="mailto:keshriabhay57@gmail.com"
                  style={{
                    padding: isMobile ? '8px 12px' : '10px 16px',
                    background: 'transparent',
                    color: '#9370db',
                    borderRadius: '6px',
                    textDecoration: 'none',
                    fontWeight: '600',
                    fontSize: isMobile ? '0.8rem' : '0.9rem',
                    transition: 'all 0.3s ease',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '6px',
                    border: '1px solid #9370db',
                    boxShadow: '0 3px 12px rgba(147, 112, 219, 0.4)',
                    position: 'relative',
                    overflow: 'hidden',
                    animation: isVisible ? 'starPulse 2.3s ease-in-out infinite' : 'none',
                    width: isMobile ? '140px' : '150px',
                    justifyContent: 'center',
                    minHeight: '32px',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.05)';
                    e.currentTarget.style.boxShadow = '0 5px 15px rgba(147, 112, 219, 0.6)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.boxShadow = '0 3px 12px rgba(147, 112, 219, 0.4)';
                  }}
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '4px' }}>
                    <path d="M3 8L10.8906 13.2604C11.5624 13.7083 12.4376 13.7083 13.1094 13.2604L21 8M5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19Z" stroke="#9370db" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Contact Me
                  <span
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      background: 'rgba(147, 112, 219, 0.2)',
                      transform: 'translateX(-100%)',
                      transition: 'transform 0.3s ease',
                    }}
                  />
                </a>
                <button
                  onClick={toggleAudio}
                  style={{
                    padding: isMobile ? '8px 12px' : '10px 16px',
                    background: isPlaying
                      ? 'linear-gradient(90deg, #4b0082, #9370db)'
                      : 'transparent',
                    color: isPlaying ? '#ffffff' : '#9370db',
                    borderRadius: '6px',
                    fontWeight: '600',
                    fontSize: isMobile ? '0.8rem' : '0.9rem',
                    transition: 'all 0.3s ease',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '6px',
                    border: '1px solid #9370db',
                    boxShadow: isPlaying
                      ? '0 3px 12px rgba(147, 112, 219, 0.5)'
                      : '0 3px 12px rgba(147, 112, 219, 0.4)',
                    position: 'relative',
                    overflow: 'hidden',
                    animation: isVisible ? 'starPulse 2.3s ease-in-out infinite' : 'none',
                    width: isMobile ? '140px' : '150px',
                    justifyContent: 'center',
                    minHeight: '32px',
                    cursor: 'pointer',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.05)';
                    e.currentTarget.style.boxShadow = '0 5px 15px rgba(147, 112, 219, 0.6)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.boxShadow = isPlaying
                      ? '0 3px 12px rgba(147, 112, 219, 0.5)'
                      : '0 3px 12px rgba(147, 112, 219, 0.4)';
                  }}
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ marginRight: '4px' }}
                  >
                    {isPlaying ? (
                      <path
                        d="M6 4H8V20H6V4ZM16 4H18V20H16V4Z"
                        fill={isPlaying ? '#ffffff' : '#9370db'}
                      />
                    ) : (
                      <path
                        d="M8 5V19L19 12L8 5Z"
                        fill={isPlaying ? '#ffffff' : '#9370db'}
                      />
                    )}
                  </svg>
                  {isPlaying ? 'Stop Audio' : 'About Me Audio'}
                  <span
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      background: isPlaying
                        ? 'rgba(255,255,255,0.2)'
                        : 'rgba(147, 112, 219, 0.2)',
                      transform: 'translateX(-100%)',
                      transition: 'transform 0.3s ease',
                    }}
                  />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Background elements */}
        <div
          style={{
            position: 'absolute',
            top: '-100px',
            right: '-100px',
            width: isMobile ? '300px' : '400px',
            height: isMobile ? '300px' : '400px',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(147, 112, 219, 0.3) 0%, rgba(0,0,0,0) 70%)',
            zIndex: -1,
            animation: 'nebulaDrift 12s ease-in-out infinite',
          }}
        />
        <div
          style={{
            position: 'absolute',
            bottom: '-150px',
            left: '-150px',
            width: isMobile ? '350px' : '500px',
            height: isMobile ? '350px' : '500px',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(75, 0, 130, 0.3) 0%, rgba(0,0,0,0) 70%)',
            zIndex: -1,
            animation: 'nebulaDACDrift 15s ease-in-out infinite',
          }}
        />

        <style jsx>{`
          @keyframes starPulse {
            0%, 100% {
              box-shadow: 0 0 12px rgba(147, 112, 219, 0.5);
            }
            50% {
              box-shadow: 0 0 18px rgba(147, 112, 219, 0.8);
            }
          }
          @keyframes nebulaGlow {
            0%, 100% {
              width: 60px;
              opacity: 0.6;
            }
            50% {
              width: 80px;
              opacity: 1;
            }
          }
          @keyframes nebulaDrift {
            0%, 100% {
              transform: translate(0, 0) scale(1);
              opacity: 0.3;
            }
            50% {
              transform: translate(20px, -20px) scale(1.1);
              opacity: 0.5;
            }
          }
          a:hover span, button:hover span {
            transform: translateX(100%);
          }
          @media (max-width: 480px) {
            section {
              padding: 20px 0 !important;
            }
            .cta-buttons {
              flex-direction: column;
              gap: 8px;
            }
            h2 {
              font-size: 1.3rem !important;
            }
            p {
              font-size: 0.8rem !important;
            }
          }
        `}</style>
      </section>
    </>
  );
};

export default Home;